<template>
  <div class="opera-infoDetail">
    <topNav :title="$t('infoDetail_title')"
            url='/opera/info'></topNav>
    <div class="infoDDateil" v-if="info.category == 1">
      <div class="envent"><span class="eventName">{{$t('infoDetail_eventName')}}:</span><span>{{info.title}}</span></div>
      <ul class="evList clearfix">
        <li class="infoLi"><span class="infoName">{{$t('infoDetail_noticeContent')}}:</span><span
          class="infoVal focus">{{infoList.noticeContent}}</span></li>
        <li class="infoLi"><span class="infoName">{{$t('infoDetail_hotelNames')}}:</span><span class="infoVal">{{infoList.hotelNames}}</span></li>
        <li class="infoLi"><span class="infoName">{{$t('infoDetail_dateCondition')}}:</span><span
          class="infoVal">{{infoList.dateCondition | fDate}}</span></li>
        <li class="infoLi"><span class="infoName">{{$t('infoDetail_checkTime')}}:</span><span class="infoVal">{{infoList.checkTime}}</span></li>
        <li class="infoLi"><span class="infoName">{{$t('infoDetail_quota')}}:</span><span class="infoVal">{{infoList.quota}}</span></li>
        <li class="infoLi "><span class="infoName">{{$t('infoDetail_quotaCondition')}}:</span><span class="infoVal">{{infoList.quotaCondition}}</span>
        </li>
        <li class="infoLi "><span class="infoName">{{$t('infoDetail_values')}}:</span><span class="infoVal focus">{{infoList.values}}</span>
        </li>
        <li class="infoLi"><span class="infoName">{{$t('infoDetail_noticeDatetime')}}:</span><span class="infoVal">{{infoList.noticeDatetime}}</span>
        </li>
      </ul>
      <div class="infoClose" @click="backlist">
        {{$t('infoDetail_close')}}
      </div>
    </div>
    <div class="infoDDateil" v-else-if="info.category == 0">
      <div class="new"><h1>{{info.title}}</h1>
        <div class="sign">{{infoList.sign}}</div>
      </div>
      <div class="newContent" v-html="infoList.content">
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'

  export default {
    data() {
      return {
        info: {},
        infoList: []
      }
    },
    mounted() {
      this.getInfo();
    },
    methods: {
      getInfo() {
        this.$http.get('/mobilepmsapi/message/messages/' + this.$route.query.id + '').then((res) => {
          this.info = res.data.retVal;
          this.infoList = JSON.parse(res.data.retVal.content);
        })
      },
      backlist() {
        if (this.$route.query.redirect != null) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push("/opera/info");
        }
      }
    },
    filters: {
      fDate(value) {
        var ts = value.split('~');
        if (ts.length == 2) {
          if (ts[0] == "0" && ts[1] == "0") {
            return "当天";
          } else {
            return ts[0] + "天到" + ts[1] + "天";
          }
        }
        return value;
      }
    },
    components: {}
  }
</script>
<style lang='less'>
  .opera-infoDetail {
    .infoDDateil {
      .envent {
        height: 1.2267rem;
        width: 8.8rem;
        margin: 0 auto;
        text-align: left;
        line-height: 1.2267rem;
        font-size: 0.4267rem;
        padding: 0.1333rem;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        color: #666;

        .eventName {
          margin-right: 0.1333rem;
        }
      }

      .evList {
        margin: 0.5333rem;
        padding-bottom: 0.8rem;
        color: #333;
        border-bottom: 1px solid #EEEEEE;

        .infoLi {
          // float: left;
          // height: 30px;
          line-height: 0.8rem;
          font-size: 0.4rem;

          &.InfoCon {
            margin: 0.5333rem 0;
          }

          .infoName {
            margin-right: 0.2667rem;

          }

          .focus {
            color: #fa8e3e
          }
        }
      }

      .new {

        margin: 0 auto;
        text-align: center;
        margin-top: 20px;
        font-size: 0.4267rem;
        padding: 0.1333rem;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;

        .sign {
          margin: 0.3rem auto;
          font-size: 12px;
          color: #aaa;
        }

      }

      .newContent {
        clear: both;
        width: 96%;
        margin: 30px auto;
        font-size: 14px;
        line-height: 25px;
      }

      .infoClose {
        text-align: center;
        font-size: 0.3233rem;
        width: 3.6533rem;
        height: 0.7333rem;
        line-height: 0.7333rem;
        margin: 0 auto;
        border: 1px solid #aaa;
        border-radius: 0.1333rem;
        color: #aaa;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// infoDetail.vue?757252f0